wbApp.controller('CompensationsCtrl', ['$scope', '$filter', 'semesterSvc', 'compensationsSvc',
function ($scope, $filter, semesterSvc, compensationsSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    function setSelectedCompensation(semesterID, compensation) {
        $scope.selectedCompensation = compensation;
        $scope.$broadcast('selectedCompensationChanged', { semesterID: semesterID, compensation: compensation });
    }

    function refreshData(semesterID) {
        setSelectedCompensation(null, null);
        $scope.comensationSummary = compensationsSvc.getAllAsync(semesterID || null);
    }

     semesterSvc.getDefaultAsync()
    .then(function (data) {
        if (data) {
            $scope.semesterID = data.id;
        }

        refreshData($scope.semesterID);
    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {
            refreshData($scope.semesterID);
        }
    }

    $scope.gridOptions = {
        sortInfo: { fields: ['studentFullName'], directions: ['asc'] },
        columnDefs: [{ field: 'studentFullName', displayName: "TXT_LBL_STUDENT", sort: 'humanName', width: '170px' },
                     { field: 'parentFullName', displayName: "TXT_LBL_PARENT", sort: 'humanName', width: '170px', smHide: true, mdHide: true },
                     { field: 'address', displayName: "TXT_LBL_ADDRESS", sort: 'locale', smHide: true },
                     { field: 'email', displayName: "TXT_LBL_EMAIL", smHide: true, mdHide: true, width: '190px' },
                     { field: 'preAmendsGranted', displayName: "TXT_LBL_PRE_AMENDS_GRANTED", width: '90px', align: 'right' },
                     { field: 'preAmendsLeft', displayName: "TXT_LBL_PRE_AMENDS_LEFT", width: '90px', align: 'right' },
                     { field: 'preAmendsTaken', displayName: "TXT_LBL_PRE_AMENDS_TAKEN", width: '90px', align: 'right' },
                     { field: 'amends', displayName: "TXT_LBL_AMENDS_LEFT", width: '90px', align: 'right' },
                     { field: 'timeBoundAmendCount', displayName: "TXT_LBL_TIME_BOUNDS_AMEND", width: '90px', align: 'right' },

        ],
        noCommandColumn: true
    };

    $scope.onRowSelected = function (data) {
        setSelectedCompensation($scope.semesterID, data);
    }

    $scope.tabs = [
    {
        title: 'TXT_LBL_COURSES',
        template: "finance/compensations/compensations-tabs/courses.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$on('refreshData', function (e, data) {
        refreshData($scope.semesterID);
    });
}]);